<div class="panel panel-success" style="height:95%;">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span class="badge">{{ selectedDocuments.Data.length }}</span>
            <span>Selected Documents</span>
        </h5>
        <div class="btn-toolbar pull-right">
            <div class="btn-group btn-group-md">
                <button type="button" class="btn btn-primary" title="Clear Selected Documents" (click)="clearSelectedDocuments()">
                    <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                </button>
            </div>
        </div>
    </div>

    <div class="panel-body panel-list" style="height:95%; overflow-y:hidden; padding-bottom:0px; padding-top:0px;">
        <div class="panel-group" style="height:95%; overflow-y:auto;" cdkDropList [cdkDropListData]="selectedDocuments">
            <div class="list-group" cdkDrag [cdkDragData]="selectedDocuments">
                <div class="list-group-item" style="padding-top:0px; padding-bottom:0px;" *ngFor="let document of selectedDocuments.Data">
                    <h5 style="display: inline-block">
                        <span class="badge"> {{ document.EquipmentCount }}</span>
                        {{ document.FileName }}
                        <br />
                        {{ document.ProductName }}
                    </h5>
                    <div class="pull-right" style="padding-right:30px;">
                        <h5 class=" label label-info">
                            {{ document.Updated | amDateFormat: 'MM/DD/YYYY'  }}
                            <br />
                            {{ document.Version }}
                        </h5>
                        <!--<span *ngIf="document.Publishing" class="text-success fa fa-check-circle" title="Publishing"></span>
                        <span *ngIf="!document.Publishing" class="text-danger fa fa-warning" title="Not Publishing"></span>-->
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</div>